import { Error } from 'coreOld/components';
import { StatusCodes } from 'coreOld/constants';
import { Loader } from 'coreOld/elements';

interface IQueryState {
  isLoading?: boolean;
  isError?: boolean;
  statusCode?: StatusCodes;
  loaderMinHeight?: number | string;
}

const withQueryState = <T,>(Component: React.ComponentType<T>) => {
  // eslint-disable-next-line react/display-name
  return (props: T & IQueryState) => {
    if (props.isLoading) {
      return <Loader fullHeight minHeight={props.loaderMinHeight} />;
    }

    if (props.isError) {
      return <Error statusCode={props?.statusCode || StatusCodes.NOT_FOUND} />;
    }

    return <Component {...props} />;
  };
};

export default withQueryState;
